import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { JsonBasketStats } from "../json-data-types/JsonBasketStats";
import css from './BasketStatsOnBottom.m.scss'
import { Price } from "./Price";
import { ServerCoupons } from "../server-queries/ServerCoupons";
import { EnumCouponType } from "../enums/EnumCouponType";
interface Attrs {
    basketStats: JsonBasketStats
}

export class BasketStatsCoupons extends DomeComponent<Attrs> {
    divByCouponCode: Record<string, HTMLDivElement> = {}


    render() {
        const basketStats = this.attrs.basketStats
        return <>
            {basketStats.discountAmountByCouponCode && Object.keys(basketStats.discountAmountByCouponCode).map(code => {
                const discountAmount = basketStats.discountAmountByCouponCode[code]
                const discountAmountDollar = basketStats.discountAmountByCouponCodeInDollar?.[code] || 0
                if (!discountAmount) return <></>
                return <>
                    <div class={css.label} ref={ref => this.divByCouponCode[code] = ref}>Скидка  <strong>{code}</strong></div>
                    <div class={css.value}> <strong>
                        {discountAmount && discountAmount > 0
                            ? <Price price={0 - discountAmount} priceInDollar={0 - discountAmountDollar} />
                            : '-'
                        }
                    </strong></div>
                </>
            })}
        </>

    }

    protected afterRender(): void {
        this.scheduleUpdate()
    }

    async updateAsync() {
        for (const [code, div] of Object.entries(this.divByCouponCode)) {
            const coupon = await ServerCoupons.getAsync(code)
            if (coupon.type === EnumCouponType.OnlyForUsers) {
                await DomeManipulator.replaceAllChildrenAsync(div,
                    <>Персональная скидка</>
                )
            }
        }
    }
}
